import React, {ReactNode} from "react";
import {css} from "@emotion/css";
import {SmallTypography, StandardTypography} from "patient-ping-remedy/packages/typography";
import {StyledTable} from "@common/Table.styles";

type SimpleTableProps = {
  data: object[];
  header?: ReactNode[] | string[];
  stickyHeader?: boolean;
}

const Table : React.FC<SimpleTableProps> = ({ data, header, stickyHeader }) => {
  const getHeaders = (header: string[] | ReactNode[]): React.ReactNode => {
    return (
      <tr>
        {header.map((item, index) => (
          <th key={index}>
            <SmallTypography>{item}</SmallTypography>
          </th>
        ))}
      </tr>
    );
  };

  const getBody = (data: object[]): React.ReactNode => {
    return (
      <React.Fragment>
        {data.map((trItem: { [index: string]: any }, index) => (
          <tr key={index}>
            {Object.keys(trItem).map((objectKey: string, index) => (
              <td key={index}>
                <StandardTypography>{trItem[objectKey]}</StandardTypography>
              </td>
            ))}
          </tr>
        ))}
      </React.Fragment>
    );
  };

  return (
    <StyledTable>
      {!!header?.length && (
        <thead className={css(stickyHeader ? { position: 'sticky', top: 0 } : {})}>
          {getHeaders(header)}
        </thead>
      )}
      <tbody>{getBody(data)}</tbody>
    </StyledTable>
  );
};

export default Table;
